(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.faq-item');

  items.forEach((item) => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    if (!answer) return;

    // Initial state
    answer.style.height = '0px';
    answer.style.overflow = 'hidden';

    question.addEventListener('click', (e) => {
      e.preventDefault();

      const isOpen = item.classList.contains('is-open');

      // Close all other items
      items.forEach((i) => {
        if (i !== item) closeItem(i);
      });

      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });
  });

  // Open first FAQ item by default
  if (items.length > 0) {
    openItem(items[0]);
  }

  function openItem(item) {
    const answer = item.querySelector('.faq-answer');
    if (!answer) return;

    item.classList.add('is-open');

    answer.style.display = 'block';
    const height = answer.scrollHeight;

    answer.style.height = '0px';

    requestAnimationFrame(() => {
      answer.style.height = height + 'px';
    });

    answer.addEventListener(
      'transitionend',
      () => {
        if (item.classList.contains('is-open')) {
          answer.style.height = 'auto';
        }
      },
      { once: true }
    );
  }

  function closeItem(item) {
    const answer = item.querySelector('.faq-answer');
    if (!answer) return;

    const height = answer.scrollHeight;

    answer.style.height = height + 'px';

    requestAnimationFrame(() => {
      answer.style.height = '0px';
    });

    item.classList.remove('is-open');
  }
});
  document.addEventListener("DOMContentLoaded", function () {
  const faqBlocks = document.querySelectorAll('.faq-block[data-faq-schema]');
  if (!faqBlocks.length) return;

  const existingSchemas = document.querySelectorAll('script[type="application/ld+json"]');
  for (const node of existingSchemas) {
    try {
      const parsed = JSON.parse(node.textContent);
      const items = Array.isArray(parsed) ? parsed : [parsed];
      if (items.some(item => item && (item['@type'] === 'FAQPage' || (Array.isArray(item['@type']) && item['@type'].includes('FAQPage'))))) {
        return;
      }
    } catch (e) {}
  }

  const mainEntity = [];

  faqBlocks.forEach(block => {
    block.querySelectorAll('.faq-item').forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      if (!question || !answer) return;

      mainEntity.push({
        "@type": "Question",
        "name": question.textContent.trim(),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answer.textContent.trim()
        }
      });
    });
  });

  if (!mainEntity.length) return;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": mainEntity
  };

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
});

  } catch(e) { console.error(e); }
})();
})();
